import { render } from "./ShoppingOffers.vue?vue&type=template&id=65591978&scoped=true"
import script from "./ShoppingOffers.vue?vue&type=script&lang=js"
export * from "./ShoppingOffers.vue?vue&type=script&lang=js"

import "./ShoppingOffers.vue?vue&type=style&index=0&id=65591978&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65591978"

export default script